import clearCalendarEventsInCache from '../store/apis/clearCalendarEventsInCache';
import getDateRange from '../store/apis/getDateRange';
import { getCalendarInfoStore } from '../store/store';
import { removeCalendarFolderIdFromLocalStorage } from './selectedCalendarsLocalStorageUtils';

/**
 * Unsubscribes from a calendar, also clears the events for the same when date range is existing.
 * @param folderId - fodler id of calendar to delete.
 */
export default function deleteCalendar(folderId: string) {
    if (getDateRange()) {
        // clear the events belonging to the folderId
        clearCalendarEventsInCache(folderId);
    }

    // Need to remove folder ids added in local storage
    removeCalendarFolderIdFromLocalStorage(folderId);
    getCalendarInfoStore().deleteCalendarInfoByFolderId(folderId);
}
